import React from 'react';
import { Hero } from '../components/Hero';
import { AudienceSplit } from '../components/AudienceSplit';
import { ServicesSection } from '../components/ServicesSection';
import { ApproachSection } from '../components/ApproachSection';
import { EmployerCta } from '../components/EmployerCta';
import { AboutPreview } from '../components/AboutPreview';
import { PartnersSection } from '../components/PartnersSection';
import { CandidateSection } from '../components/CandidateSection';
import { ContactPrompt } from '../components/ContactPrompt';
export function Home() {
  return <>
      <Hero data-id="element-427" data-mp="29flrk1ujboxw" />
      <AudienceSplit data-id="element-428" data-mp="29fvh5obo3u32" />
      <ServicesSection data-id="element-429" data-mp="29fbwhzumurlc" />
      <ApproachSection data-id="element-430" data-mp="29i80a4t5wahp" />
      <EmployerCta data-id="element-431" data-mp="2dhgrp30qbwa3" />
      <AboutPreview data-id="element-432" data-mp="2dhyw4mxjpgt3" />
      <PartnersSection data-id="element-433" data-mp="2dii2d6du2gra" />
      <CandidateSection data-id="element-434" data-mp="2dfm41gy2pq2b" />
      <ContactPrompt data-id="element-435" data-mp="3kvac6mkbgbvj" />
    </>;
}